import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-110c3194")
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = ["value", "selected"]
const _hoisted_3 = { class: "v-input__details" }
const _hoisted_4 = { class: "ml-4 text-error text-caption" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "text-subtitle" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ') + " ")
const _hoisted_10 = { key: 2 }
_popScopeId()

import ConditionDialog from '@/components/Editor/Dialog/ConditionDialog/ConditionDialog.vue'
import Conditions from './components/Conditions.vue'
import { readableConditionOperators, readableConditionScopes, readableNumberOperators } from '@/lib/helper'
import { withDefaults, watch, onMounted, ref } from 'vue'
import { required } from '@/lib/validation'
import { useField } from 'vee-validate'
import { ITriggerEvent, IStepData, IConditionGroup, IConditionField } from '@/interfaces/hoppermation'
import createHoppermationAPIClient from '@/clients/hoppermation'
import { AxiosInstance } from 'axios'
import eventBus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'
import { getEventLabel } from '@/lib/helper'

interface IProps {
  updateNodeData?: (data: IStepData) => void
  details?: IStepData
}


export default /*#__PURE__*/_defineComponent({
  props: {
    updateNodeData: { type: Function, required: false, default: () => ({}) },
    details: { type: null, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { updateNodeData: (data: IStepData) => void, details: IStepData }
const hoppermationApiClient = ref({} as AxiosInstance)
const triggerEvents = ref([] as ITriggerEvent[])
const conditionFields = ref([] as IConditionField[])



onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
  getEvents()
  getConditionFields()
})

const getEvents = async (): Promise<void> => {
  try {
    const res = await hoppermationApiClient.value.get('/trigger-events')
    triggerEvents.value = res.data
  } catch (error) {
    eventBus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.channels.fetch.error' })
  }
}

const getConditionFields = async (): Promise<void> => {
  try {
    const res = await hoppermationApiClient.value.get('/condition-fields')
    conditionFields.value = res.data
  } catch (error) {
    eventBus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.channels.fetch.error' })
  }
}

const { errorMessage, value: eventName } = useField('eventName', required, {
  initialValue: props.details.eventName
})

watch(eventName, (value) => {
  props.updateNodeData({ eventName: value, eventLabel: getEventLabel(triggerEvents.value, value) })
})

const condition = ref(props.details.condition)

const editCondition = (updatedCondition: IConditionGroup): void => {
  if (condition.value) {
    condition.value = updatedCondition
    props.updateNodeData({ condition: condition.value })
  }
}

const deleteCondition = (index: number) => {
  condition.value?.conditions.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          class: _normalizeClass(["row-max", _unref(errorMessage) ? 'mb-3' : ''])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "pa-0" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "px-4 width-full select",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(eventName) ? eventName.value = $event : null))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(triggerEvents.value, ({ event, eventLabel }) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: event,
                      value: event,
                      selected: event === _unref(eventName)
                    }, _toDisplayString(eventLabel), 9, _hoisted_2))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(eventName)]
                ]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('details.goal.eventName.hint')), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(errorMessage) ? _ctx.$t(_unref(errorMessage)) : ''), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('details.condition.conditions.title')), 1),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('details.condition.conditions.desc2.1')) + " ", 1),
          (condition.value?.operator)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_7, _toDisplayString(_ctx.$t(_unref(readableConditionOperators)(condition.value.operator))), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('details.condition.conditions.desc2.2')) + " ", 1),
          (condition.value?.scope)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString(_ctx.$t(_unref(readableConditionScopes)(condition.value.scope))), 1))
            : _createCommentVNode("", true),
          _hoisted_9,
          (condition.value?.count && condition.value?.countOperator)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_10, _toDisplayString(_ctx.$t(_unref(readableNumberOperators)(condition.value?.countOperator))) + " " + _toDisplayString(condition.value?.count) + " " + _toDisplayString(_ctx.$t('details.condition.conditions.desc2.4')), 1))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('details.condition.conditions.desc2.3')), 1)
        ]),
        _createVNode(Conditions, {
          items: condition.value?.conditions,
          "remove-item": deleteCondition,
          "condition-fields": conditionFields.value
        }, null, 8, ["items", "condition-fields"]),
        _createVNode(ConditionDialog, {
          condition: condition.value,
          "edit-condition": editCondition,
          "condition-fields": conditionFields.value
        }, null, 8, ["condition", "condition-fields"])
      ]),
      _: 1
    })
  ]))
}
}

})